import { useEffect, useState, useContext } from "react";  
import './../../../index.css'
import systemContext from "../../../_context/systemContext";
import { Modal, Spinner } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import { vscService } from "../../../_services/vscService";
import { FaEdit, FaTrash, FaPlus } from "react-icons/fa";
import { Tooltip } from 'react-tooltip';
import SegmentoModal from "../Modales/ModalSegmentos";
import '../../../DataTable.css';
import Swal from 'sweetalert2';
import BreadcrumbCatalogos from './BreadcrumbCatalogos';

const Segmentos = () => {    
    const SystemContext = useContext(systemContext);
    const user = SystemContext.getUser();
    const [showLoader, setShowLoader] = useState(true);
    const [datos, setDatos] = useState([]);
    const [loading, setLoading] = useState(false);
    const [filterText, setFilterText] = useState('');
    // Estados para el modal
    const [showModal, setShowModal] = useState(false);
    const [segmentoEdit, setSegmentoEdit] = useState(null);
    const [modalLoading, setModalLoading] = useState(false);

    // Columnas para React Data Table
    const columns = [
        {
            name: 'Clave',
            selector: row => row.clave,
            sortable: true,
            wrap: true,
            width: '100px'
        },
        {
            name: 'Descripción',
            selector: row => row.descripcion,
            sortable: true,
            wrap: true,
            minWidth: '400px',
            grow: 2,
        },
        {
            name: 'Acciones',
            cell: row => (
                <div className="nova-grid-actions">
                    <button 
                        className="nova-btn-action nova-btn-edit"
                        onClick={() => handleEdit(row)}
                        data-tooltip-id="edit-tooltip"
                        data-tooltip-content="Editar segmento"
                    >
                        <FaEdit className="nova-action-icon" />
                    </button>
                    <button 
                        className="nova-btn-action nova-btn-delete"
                        onClick={() => handleDelete(row.clave)}  // Usar clave en lugar de id
                        data-tooltip-id="delete-tooltip" 
                        data-tooltip-content="Eliminar segmento"
                    >
                        <FaTrash className="nova-action-icon" />
                    </button>
                </div>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
            width: '120px',
        },
    ];

    // Filtrado de datos
    const filteredItems = datos.filter(item =>
        item.clave?.toLowerCase().includes(filterText.toLowerCase()) ||
        item.descripcion?.toLowerCase().includes(filterText.toLowerCase())
    );

    // Estilos personalizados para la tabla (los mismos que motivos)
    const customStyles = {
        headRow: {
            style: {
                backgroundColor: 'var(--primary-color)',
                color: 'white',
                fontSize: '0.9rem',
                fontWeight: '600',
                minHeight: '50px',
                borderBottom: '2px solid rgba(255, 255, 255, 0.3)',
            },
        },
        headCells: {
            style: {
                paddingLeft: '12px',
                paddingRight: '12px',
                fontSize: '0.85rem',
                fontWeight: '600',
            },
        },
        cells: {
            style: {
                paddingLeft: '10px',
                paddingRight: '10px',
                fontSize: '0.75rem',
                color: 'var(--text-dark)',
            },
        },
        rows: {
            style: {
                fontSize: '0.75rem',
                minHeight: '32px',
                '&:nth-child(even)': {
                    backgroundColor: 'rgba(0, 50, 139, 0.02)',
                },
                '&:hover': {
                    backgroundColor: 'rgba(0, 50, 139, 0.05) !important',
                },
            },
            stripedStyle: {
                backgroundColor: 'rgba(0, 50, 139, 0.02)',
            },
        },
        pagination: {
            style: {
                fontSize: '0.7rem',
                borderTop: '1px solid rgba(0, 50, 139, 0.1)',
                color: 'var(--text-dark)',
            },
        },
    };

    // Opciones de paginación en español
    const paginationComponentOptions = {
        rowsPerPageText: 'Filas por página:',
        rangeSeparatorText: 'de',
        selectAllRowsItem: true,
        selectAllRowsItemText: 'Todos',
    };

    // Componente de búsqueda
    const subHeaderComponent = (
        <div className="nova-table-search">
            <input
                type="text"
                placeholder="Buscar por clave o descripción..."
                className="nova-search-input"
                value={filterText}
                onChange={e => setFilterText(e.target.value)}
            />
            <div className="nova-search-results">
                {filteredItems.length} de {datos.length} registros
            </div>
        </div>
    );

    // Componente cuando no hay datos
    const NoDataComponent = () => (
        <div className="nova-no-data">
            <div className="nova-no-data-icon">📊</div>
            <h3>No se encontraron segmentos</h3>
            <p>No hay segmentos registrados en el sistema.</p>
        </div>
    );

    
    useEffect(() => {
        getSegmentos();
    }, []);

    const getSegmentos = async () => 
    {
        try {
            setLoading(true);
            // IMPORTANTE: Cambiar por tu servicio real de segmentos
            const respuesta = await vscService.getSegmentos();            
            if (respuesta.status === "OK") {
                const datos = respuesta.content.segmentos || respuesta.content.data || respuesta.data || [];
                setDatos(datos); 
            } else {
                throw new Error(respuesta.message || 'Error al cargar segmentos');
            }
        } catch (error) {
            console.error('Error en obtener segmentos:', error);
            setDatos([]);            
            await Swal.fire({
                position: "top-end",
                icon: "error",
                title: "Error al cargar los segmentos.",
                text: error.message || "Por favor, intenta nuevamente.",
                showConfirmButton: false,
                timer: 2000,
                customClass: {
                    popup: 'nova-swal-popup'
                }
            });
        } finally {
            setLoading(false);
        }
    };

    // Handlers
    const handleAddNew = () => {
        setSegmentoEdit(null); // Modo creación
        setShowModal(true);
    };

    const handleEdit = (segmento) => {
        setSegmentoEdit(segmento); // Modo edición
        setShowModal(true);
    };

    const handleDelete = async (clave) => 
    {
        const segmento = datos.find(item => item.clave === clave);    
        const result = await Swal.fire({
            title: '¿Estás seguro?',
            text: `¿Quieres eliminar el segmento "${segmento?.clave}"? Esta acción no se puede deshacer.`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar',
            reverseButtons: true,
            customClass: {
                popup: 'nova-swal-popup',
                confirmButton: 'nova-swal-confirm',
                cancelButton: 'nova-swal-cancel'
            }
        });

        if (result.isConfirmed) {
            setLoading(true);
            try {
                const resultado = await vscService.delEliminaSegmento(clave);                
                if (resultado.statusText === "OK" || resultado.success) {
                    await getSegmentos();                    
                    await Swal.fire({
                        position: "top-end",
                        icon: "success",
                        title: "Segmento eliminado con éxito.",
                        showConfirmButton: false,
                        timer: 1500,
                        customClass: {
                            popup: 'nova-swal-popup'
                        }
                    });
                } else {
                    throw new Error(resultado.message || 'Error al eliminar');
                }
            } catch (error) {
                console.error('Error al eliminar segmento:', error);
                
                await Swal.fire({
                    position: "top-end",
                    icon: "error",
                    title: "Error al eliminar el segmento.",
                    text: error.message || "Por favor, intenta nuevamente.",
                    showConfirmButton: false,
                    timer: 2000,
                    customClass: {
                        popup: 'nova-swal-popup'
                    }
                });
            } finally {
                setLoading(false);
            }
        }
    };

    const handleSaveSegmento = async (formData, claveOriginal) => 
    {
        setModalLoading(true);
        try {
            // Preparar datos para segmento
            const segmentoData = {
                clave: formData.clave,
                descripcion: formData.descripcion
            };
            
            console.log('Datos a guardar:', segmentoData);
            console.log('Clave original:', claveOriginal);
            
            let resultado;
            
            if (claveOriginal) {
                // Modo edición - tenemos una clave original (la que se está editando)
                resultado = await vscService.putEditaSegmento(segmentoData);
            } else {
                // Modo creación
                resultado = await vscService.postInsertaSegmento(segmentoData);
            }

            if (resultado.status === "OK" || resultado.success) {
                await getSegmentos();                
                setShowModal(false);
                setSegmentoEdit(null);
                    
                await Swal.fire({
                    position: "top-end",
                    icon: "success",
                    title: claveOriginal ? "Segmento actualizado con éxito." : "Segmento creado con éxito.",
                    showConfirmButton: false,
                    timer: 1500,
                    customClass: {
                        popup: 'nova-swal-popup'
                    }
                });
            } else {
                throw new Error(resultado.message || 'Error en la operación');
            }            
        } catch (error) {
            console.error('Error al guardar segmento:', error);            
            await Swal.fire({
                position: "top-end",
                icon: "error",
                title: "Error al guardar el segmento.",
                text: error.message || "Por favor, intenta nuevamente.",
                showConfirmButton: false,
                timer: 2000,
                customClass: {
                    popup: 'nova-swal-popup'
                }
            });
        } finally {
            setModalLoading(false);
        }
    };

    return (
        <div className="nova-dashboard-balanced">
            {/* Header de la página */}
            <div className="nova-page-header">
                <h3 className="nova-page-title">Catálogo de Segmentos</h3>
                <div className="nova-header-actions-right">
                    <BreadcrumbCatalogos />
                <button 
                    className="nova-btn-primary"
                    onClick={handleAddNew}
                >
                    <FaPlus className="me-2" />
                    Agregar Nuevo Segmento
                </button>
                </div>
            </div>

            {/* Contenedor de la tabla */}
            <div className="nova-data-table-container">
                <DataTable
                    columns={columns}
                    data={filteredItems}
                    customStyles={customStyles}
                    className="nova-react-datatable"
                    pagination
                    paginationPerPage={10}
                    paginationRowsPerPageOptions={[10, 25, 50]}
                    paginationComponentOptions={paginationComponentOptions}
                    progressPending={loading}
                    progressComponent={
                        <div className="nova-grid-loading">
                            <Spinner animation="border" role="status" />
                            <p>Cargando segmentos...</p>
                        </div>
                    }
                    subHeader
                    subHeaderComponent={subHeaderComponent}
                    noDataComponent={<NoDataComponent />}
                    highlightOnHover
                    striped
                    responsive
                    fixedHeader
                    fixedHeaderScrollHeight="700px"
                    persistTableHead
                />
            </div>

            {/* Modal para crear/editar */}
            <SegmentoModal
                show={showModal}
                onHide={() => {
                    setShowModal(false);
                    // No limpiar segmentoEdit aquí para evitar problemas
                }}
                segmento={segmentoEdit}
                onSave={handleSaveSegmento}
                loading={modalLoading}
            />

            {/* Tooltips */}
            <Tooltip id="edit-tooltip" place="top" />
            <Tooltip id="delete-tooltip" place="top" />
        </div>
    );
};

export default Segmentos;